import { useGetDevelopmentDetailQuery as useGetDevelopmentsTokkoQuery } from '@apis/middlewareTokkoApi/developments'
import { useGetDevelopmentMiddlewareQuery as useGetDevelopmentMiddlewareQuery } from '@apis/mediacore/owner'
import { useGetDevelopmentQuery as useGetDevelopmentsMediacoreQuery } from '@apis/mediacore/emprendimientos'
import {
  useGetDevelopmentXintelQuery,
  xintelDevelopmentsExtended as developmentXintel,
} from '@apis/integrations/xintel'

import { ownerExtended as developmentMediacore } from '@apis/mediacore/owner'
import { developmentsExtended as developmentABM } from '@apis/mediacore/emprendimientos'
import { developmentExtended as developmentTokko } from '@apis/middlewareTokkoApi/developments'
import { useGlobalData } from '@context/GlobalDataContext'

// 🧠 Prefetch unificado para todas las fuentes (usa los mismos endpoints que el hook)
export function prefetchQueryDevelopment(
  dispatch: any,
  id?: string,
  tokkoKey?: string,
  xintelKey?: string,
) {
  if (!id) return
  const middlewarev2 = process.env.GATSBY_USE_MIDDLEWARE_V2?.toLowerCase() === 'true'
  const shouldUseXintel = !tokkoKey && Boolean(xintelKey)

  if (tokkoKey) {
    if (middlewarev2) {
      return dispatch(
        developmentMediacore.endpoints.getDevelopmentMiddleware.initiate({
          DEVELOPMENT_ID: id,
        }),
      )
    } else {
      return dispatch(
        developmentTokko.endpoints.getDevelopmentDetail.initiate({
          API_KEY: tokkoKey,
          DEVELOPMENT_ID: id,
        }),
      )
    }
  } else if (shouldUseXintel) {
    return dispatch(
      developmentXintel.endpoints.getDevelopmentXintel.initiate({
        DEVELOPMENT_ID: id,
      }),
    )
  } else {
    // 👇 Este endpoint correcto es getDevelopment
    return dispatch(
      developmentABM.endpoints.getDevelopment.initiate({
        CLIENT_ID: process.env.GATSBY_CLIENTID!,
        DEVELOPMENT_ID: id,
      }),
    )
  }
}

function useQueryDevelopment(id?: string, tokkoKey?: string) {
  const skip = !id

  const global_data = useGlobalData()
  const xintelKey = global_data?.pageConfig?.keys?.xintel
  const middlewarev2: boolean = process.env.GATSBY_USE_MIDDLEWARE_V2?.toLowerCase() === 'true'
  const shouldUseXintel = !tokkoKey && Boolean(xintelKey)

  const { data, isLoading, isError, isFetching } = tokkoKey
    ? middlewarev2
      ? useGetDevelopmentMiddlewareQuery({ DEVELOPMENT_ID: id }, { skip })
      : useGetDevelopmentsTokkoQuery({ API_KEY: tokkoKey, DEVELOPMENT_ID: id }, { skip })
    : shouldUseXintel
    ? useGetDevelopmentXintelQuery({ DEVELOPMENT_ID: id }, { skip })
    : useGetDevelopmentsMediacoreQuery(
        {
          CLIENT_ID: process.env.GATSBY_CLIENTID,
          DEVELOPMENT_ID: id,
        },
        { skip, refetchOnMountOrArgChange: false },
      )

  return { data, isLoading, isError, isFetching }
}

export default useQueryDevelopment
